export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const companyStore = useCompanyStore()
	if (companyStore.careerDomainCompany?.id) {
		return navigateTo(routeUrl.CompanyCareersUrl(companyStore.careerDomainCompany?.id))
	}
})
